import React, { useState, useEffect } from 'react';
import './Slideshow.css';

const Slideshow = ({ images, interval,github,video}) => {

  console.log("live",video)
  const [fullscreen, setFullscreen] = useState(false);
  // const [fullscreen, setFullscreen] = useState(false);
  const [activeDiv, setActiveDiv] = useState(false);

  const toggleFullscreen = () => {
    setFullscreen(!fullscreen);
    // setActiveDiv(fullscreen ? 1 : 2);
  };

  const toggleActiveDiv = () => {
    setActiveDiv(!activeDiv);
  };

  const [currentIndex, setCurrentIndex] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);

  const toggleAutoPlay = () => {
    setAutoPlay(!autoPlay);
  };

  const handleArrowClick = (direction) => {
    if (direction === 'prev') {
      setCurrentIndex((currentIndex - 1 + images.length) % images.length);
    } else if (direction === 'next') {
      setCurrentIndex((currentIndex + 1) % images.length);
    }
  };

  useEffect(() => {
    let intervalId;

    if (autoPlay) {
      intervalId = setInterval(() => {
        setCurrentIndex((currentIndex + 1) % images.length);
      }, interval);
    }

    return () => clearInterval(intervalId);
  }, [autoPlay, currentIndex, images.length, interval]);

  return (
  <div>
  
      <div className={activeDiv ? 'div2' :''} >
        {video}
        {/* <h1>here is showing</h1> */}
      </div>


      <div className={!activeDiv ? 'div2' : ''} style={activeDiv ? {} : {padding: '75% 0 0 0', position: 'relative'}}>

        <div className={`slideshow ${fullscreen ? 'fullscreen' : ''}`}  >
          

          <img
            src={images[currentIndex]}
            alt={`image ${currentIndex}`}
            className="slide"
          />
          <div className="nav-buttons">
            <button className="arrow left" onClick={() => handleArrowClick('prev')}>
              &#60;
            </button>
            <button className="arrow right" onClick={() => handleArrowClick('next')}>
              &#62;
            </button>
          </div>

          <div className= {`${fullscreen ? 'fullscreen-toggle' : ''}`} >
            <a href ={github} className="btn btn btn-primary" target="_blank" onClick={toggleFullscreen}>Github</a>
            <a href ={github} className="btn btn btn-primary" target="_blank" onClick={toggleFullscreen}>Live Demo</a>
            <button className= "btn btn btn-primary" onClick={toggleFullscreen}>Exit full screen</button>
        </div>
        <div className={` ${fullscreen ? 'showautoplay btn btn-primary' : 'hideautoplay '} `}>
            <label>
              Auto Play:
              <input
                type="checkbox"
                checked={autoPlay}
                onChange={toggleAutoPlay}
              />
            </label>
          </div>
        </div>
      </div>
     <div className="portfolio_item_cta">
            <button className= 'btn btn-primary' onClick={toggleActiveDiv}>{activeDiv ? 'Video Demo' : 'Picture demo'}</button>

            <button className={activeDiv ? (`${fullscreen ? 'fullscreen-toggle' : 'btn btn-primary'}`):''} onClick={toggleFullscreen}> {activeDiv ?
  (fullscreen ? 'Exit Fullscreen' : 'Full Screen') :''}
</button>
            <a href ={github} className="btn btn btn-primary" target="_blank">Github</a>
    </div>

    {/* className={`slideshow }`} */}
  
   </div>
  );
};

export default Slideshow;
